import React, {useEffect, useRef} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import { withRouter } from "react-router-dom";

import Button from "@mui/material/Button";

import WithOverlay from "../../popups/withOverlayHoc";
import {
  setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened,
  setLookReturnAction
} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {ROUTES} from "../../../routes";
import {getCurrentLayout} from "../../appLayout";
import WithSavePostMessage from "../hocs/withSavePostMessage";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";
import {isIframe} from "../../../misc/helpers";
import {applyNewPreset} from "../lookNavigation/lookNavigationFunctions";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {removeJobFromLocalStorage, restoreJobFromLocalStorage} from "../../../misc/jobLocalStorageRestore";
import {setJobLocalStorageSaveBlocked} from "../../../misc/jobLocalStorageSave";

const LookQuestionPopup = (props) => {

  const {lookOverlayOpened, setLookOverlayOpened, setLookPageOpened, history, lookViewChangeOptions, bvPresets,
    activePreset, setLookOpened, lookReturnAction, fabricatorData, setLookReturnAction, loadedPresets, updateCanvasCount} = props;
  const questionPopups = [
    LOOK_OVERLAYS.questionLogin,
    LOOK_OVERLAYS.questionShare,
    LOOK_OVERLAYS.questionView,
    LOOK_OVERLAYS.questionViewUpdated,
    LOOK_OVERLAYS.questionRestore,
    LOOK_OVERLAYS.reset,
    LOOK_OVERLAYS.saveSucess,
  ];

  const hideOverlayRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      const isEsc = e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
      if (!isEsc || e.repeat) return;
      // const el = e.target;
      // const isTyping =
      //   el && (
      //     el.tagName === "INPUT" ||
      //     el.tagName === "TEXTAREA" ||
      //     el.isContentEditable
      //   );
      // if (isTyping) return;

      if (!lookOverlayOpened || !questionPopups.includes(lookOverlayOpened)) return;
      closeClick(); // will no-op safely if ref isn't ready
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookOverlayOpened]);

  if (!lookOverlayOpened || !questionPopups.some(popupType => popupType === lookOverlayOpened)) {
    return null
  }

  const closePopup = (hideOverlay) => {
    if (lookReturnAction) {
      setLookReturnAction("");
    }
    hideOverlay(() => {
      setLookOverlayOpened("");
    })
  }

  const submitButtonClick = async (hideOverlay, savePostMessage, updateLookCartItem) => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin:
      case LOOK_OVERLAYS.questionShare: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupLogin
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupLogin;
        Analytics.sendClickEvent(analyticsLabel);
        const isLixil = isIframe() && fabricatorData.isLixil;
        if (lookOverlayOpened === LOOK_OVERLAYS.questionShare && !isLixil) { // we will show login popup so no need to close overlay
          setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
          break;
        }
        closePopup(hideOverlay);
        setLookPageOpened("");
        // history.push(ROUTES.login);
        savePostMessage();

        break;
      }
      case LOOK_OVERLAYS.questionView: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupChangeViewSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupChangeViewSubmit;
        Analytics.sendClickEvent(analyticsLabel);

        const {newLayoutType, newScene} = lookViewChangeOptions;
        const layout = getCurrentLayout();
        layout.selectLayout(newLayoutType, null, null, newScene, () => {
          setLookPageOpened("");
          if (IS_PRODUCT_JOURNEY) {
            setLookOpened(null);
          }
          history.push(ROUTES.home);
          closePopup(hideOverlay);
          updateLookCartItem();
        });
        // setLookOverlayOpened(LOOK_OVERLAYS.questionViewUpdated);
        break;
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        closePopup(hideOverlay);
        setLookPageOpened("");
        history.push(ROUTES.home);
        break;
      }
      case LOOK_OVERLAYS.questionRestore: {
        closePopup(hideOverlay);
        loaderEnable();
        try {
          // restores all rooms the same way as the saved job is restored
          await restoreJobFromLocalStorage();
          updateCanvasCount();
        } catch (ex) { console.log("applyStoredItems localStorage exception", ex); }
        setJobLocalStorageSaveBlocked(false); // blocked until the restore question is answered (just in case the restore failed)
        loaderDisable();
        break;
      }
      case LOOK_OVERLAYS.reset: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupResetSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupSaveResetSubmit;
        Analytics.sendClickEvent(analyticsLabel);

        closePopup(hideOverlay);
        setLookPageOpened("");
        history.push(ROUTES.home);

        let presetToSet = null;
        if (Number.isInteger(activePreset)) {
          presetToSet = bvPresets.find(preset => preset.id === activePreset);
        }
        if (!presetToSet) {
          presetToSet = bvPresets.find(preset => preset.loadByTheDefault)
        }
        if (presetToSet) {
          console.log("defaultPreset", presetToSet);
          applyNewPreset(presetToSet, loadedPresets);
        }
        break;
      }
      case LOOK_OVERLAYS.saveSucess: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productPopupSaveSuccessSubmit
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookPopupSaveSuccessSubmit;
        Analytics.sendClickEvent(analyticsLabel);
        closePopup(hideOverlay);
        break;
      }
    }
  }

  const getTitle = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin: { // is only for lixil
        return isIframe() ? "questionPopup.wishlist.title" : "questionPopup.wishlist.title2"
      }
      case LOOK_OVERLAYS.questionShare: {
        return "questionPopup.share.title"
      }
      case LOOK_OVERLAYS.questionView: {
        return "questionPopup.view.title"
      }
      case LOOK_OVERLAYS.questionRestore: {
        return "messageBox.restoreSessionTitle"
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.title"
      }
      case LOOK_OVERLAYS.reset: {
        return "resetPopup.title"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "savePopup.title"
      }
    }
    return ""
  }

  const getDescription = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionLogin: {
        return "questionPopup.wishlist.text"
      }
      case LOOK_OVERLAYS.questionShare: {
        return "questionPopup.share.text"
      }
      case LOOK_OVERLAYS.questionView: {
        return "questionPopup.view.text"
      }
      case LOOK_OVERLAYS.questionRestore: {
        return "messageBox.restoreSessionText"
      }
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.text"
      }
      case LOOK_OVERLAYS.reset: {
        return "resetPopup.text"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "savePopup.text"
      }
    }
    return ""
  }

  const getButtonText = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionViewUpdated: {
        return "questionPopup.viewUpdated.button"
      }
      case LOOK_OVERLAYS.reset:
      case LOOK_OVERLAYS.questionRestore: {
        return "buttons.yes"
      }
      case LOOK_OVERLAYS.saveSucess: {
        return "buttons.continue"
      }
    }
    return "buttons.confirm"
  }

  const getCancelButtonText = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionRestore: {
        return "messageBox.buttonNo"
      }
      default:
        break;
    }
    return "buttons.cancel"
  }

  const closeClick = () => {
    const hideOverlay = hideOverlayRef.current;
    if (!hideOverlay) return; // avoid calling with null

    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.questionRestore: {
        removeJobFromLocalStorage();
        setJobLocalStorageSaveBlocked(false); // blocked until the restore question is answered
        break;
      }
      default:
        break;
    }
    closePopup(hideOverlay);
  };


  return (
    <WithOverlay>
      {(hideOverlay) => {
        hideOverlayRef.current = hideOverlay;
        return (
          (
            <div className="look-popup look-popup--question" style={lookOverlayOpened === LOOK_OVERLAYS.questionRestore ? {
              width: "100%",
              maxWidth: "680px",
            } : null}>
              <div className="look-popup__content">
                <h2 className="h2 h2--regular text-left">
                  <FormattedMessage id={getTitle()}/>
                </h2>
                <p className="text text-left">
                  <FormattedMessage id={getDescription()}/>
                </p>
              </div>
              <div className={"look-popup__buttons"
                + (lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated ? " look-popup__buttons--right" : "")}>
                {lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated || lookOverlayOpened === LOOK_OVERLAYS.saveSucess ? null : (
                  <Button className={"look-button look-button--secondary look-button--min"}
                          onClick={closeClick}>
                    <FormattedMessage id={getCancelButtonText()}/>
                  </Button>
                )}
                <WithUpdateLookCartItem>
                  {(updateLookCartItem) => (
                    <WithSavePostMessage>
                      {(savePostMessage) => (
                        <Button className={"look-button look-button--primary"
                          + (lookOverlayOpened === LOOK_OVERLAYS.questionViewUpdated ? " look-button--large" : " look-button--min")}
                                onClick={() => submitButtonClick(hideOverlay, savePostMessage, updateLookCartItem)}>
                          <FormattedMessage id={getButtonText()}/>
                        </Button>
                      )}
                    </WithSavePostMessage>
                  )}
                </WithUpdateLookCartItem>
              </div>
            </div>
          )
        )
      }}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookViewChangeOptions, lookReturnAction} = store.lookState;
  const {bvPresets, activePreset, loadedPresets} = store.bathroomVisualizerState;
  const fabricatorData = store.fabricatorState;

  return {
    lookOverlayOpened,
    lookViewChangeOptions,
    bvPresets,
    loadedPresets,
    activePreset,
    lookReturnAction,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setLookOpened,
  setLookReturnAction,
  updateCanvasCount,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookQuestionPopup)
)
